module.exports = __webpack_public_path__ + "img/indexLogo.39aa42f3.png";